import { createWithEqualityFn } from 'zustand/traditional';
import { persist } from 'zustand/middleware';

import { createUserStoreSlice } from '@store/User';
import { createPortalContextSlice } from '@store/PortalContextStore';
import { shallow } from 'zustand/shallow';
import { TGlobalStore } from '@store/types/GlobalStore.type';

const persistedFields = ['layoutPreferences', 'walkthroughs'];

export const useStore = createWithEqualityFn<TGlobalStore>()(
  persist(
    (...args) => ({
      ...createUserStoreSlice(...args),
      ...createPortalContextSlice(...args),
    }),
    {
      name: 'lio-global-storage',
      version: 1.2,
      partialize: (state) => Object.fromEntries(Object.entries(state).filter(([key]) => persistedFields.includes(key))),
    },
  ),
  shallow,
);
